import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community/main';
import { IHeaderAngularComp } from 'ag-grid-angular/main';
import { IHeaderParams } from 'ag-grid-community/main';
import { DataRevisionIndicator } from '../shared';
import { ModalDialogService } from '../on-screen-results/standard-test-results/model-dialog/ModalDialogService';
import { ModalData } from '../on-screen-results/standard-test-results/model-dialog/data-revision/data-revision.component';
import { StandardTestResultsData } from '../on-screen-results/standard-test-results/standard-test-result-data';

interface VisitHeaderParams extends IHeaderParams, ICellRendererParams {
    routerLink: any[] | string;
    queryParams?: { [k: string]: any };
    text: string | number;
    hasDataRevision: boolean;
    labTestId: number;
    subjectNumber: string;
}

@Component({
    selector: 'lab-tests-grid-visit-header',
    template: require('./lab-tests-grid-visit-header.component.html'),
    styles: [require('./lab-tests-grid-visit-header.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LabTestGridVisitHeaderComponent implements IHeaderAngularComp {

    public params: VisitHeaderParams;

    public revisionMessage: string;

    public labtestId: number;
    public protocol: string;
    public participantNumber: string;
    public investigatorNumber: string;
    public accessionNumber: string;
    public visitDescription: string;


    constructor(
        private dataRevisionIndicator: DataRevisionIndicator, public modalDialogService: ModalDialogService) {

        this.revisionMessage = this.dataRevisionIndicator.visitDataRevisionMessage;
    }

    public agInit(params: VisitHeaderParams): void {
        this.params = params;

        this.labtestId = params.labTestId;
        this.protocol = 'Loading..';
        this.participantNumber = params.subjectNumber;
        this.investigatorNumber = 'Loading..';
        this.accessionNumber = params.text.toString();
        this.visitDescription = params.displayName;
    }

    public openpopup(labtestId: number) {
        let data: ModalData = {
            title: 'Data Change',
            data: [],
            protocol: this.protocol,
            participantNumber: this.participantNumber,
            investigatorNumber: this.investigatorNumber,
            accessionNumber: this.accessionNumber,
            visitDescription: this.visitDescription,
            closeButtonText: 'Close',
            reverseButtons: true,
            displayClose: false,
            type: 'visit',
            labTestId: labtestId
        };
        this.modalDialogService.showDialog(data).toPromise();
    }
    public get hasData() {
        return !!this.params;
    }
}